import React from 'react';
import Highcharts from 'highcharts/highcharts';
import HighchartsReact from 'highcharts-react-official';

import { InlineMath, BlockMath } from 'react-katex';
import 'katex/dist/katex.min.css';

import sr_orig from './sr_orig';
import sr_1_5 from './sr_1_5';
import sr_1_6 from './sr_1_6';
import sr_1_7 from './sr_1_7';
import sr_1_8 from './sr_1_8';

const base = {
  credits: {
    enabled: false
  },
  plotOptions: {
    series: {
      enableMouseTracking: false,
      lineWidth: 1
    },
  },
  yAxis: {
    title: { enabled: false },
    min: -0.2,
    max: 0.4,
    tickInterval: 0.1
  },
};

const sr1 = {
  ...base,
  title: {
    text: 'r = 1.5',
    margin: 1,
    style: { fontSize: '12px' },
  },
  series: [
    {
      marker: { enabled: true, radius: 3 },
      data: sr_orig.slice(991, 1074),
      name: 'Training Data'
    },
    {
      marker: { enabled: true, radius: 3 },
      data: sr_1_5.slice(0, 73),
      name: 'Reservoir Prediction'
    }
  ]
};

const sr2 = {
  ...base,
  title: {
    text: 'r = 1.6',
    margin: 1,
    style: { fontSize: '12px' },
  },
  series: [
    {
      marker: { enabled: true, radius: 3 },
      data: sr_orig.slice(991, 1074),
      name: 'Training Data'
    },
    {
      marker: { enabled: true, radius: 3 },
      data: sr_1_6.slice(0, 73),
      name: 'Reservoir Prediction'
    }
  ]
};

const sr3 = {
  ...base,
  title: {
    text: 'r = 1.7',
    margin: 1,
    style: { fontSize: '12px' },
  },
  series: [
    {
      marker: { enabled: true, radius: 3 },
      data: sr_orig.slice(991, 1074),
      name: 'Training Data'
    },
    {
      marker: { enabled: true, radius: 3 },
      data: sr_1_7.slice(0, 73),
      name: 'Reservoir Prediction'
    }
  ]
};

const sr4 = {
  ...base,
  title: {
    text: 'r = 1.8',
    margin: 1,
    style: { fontSize: '12px' },
  },
  series: [
    {
      marker: { enabled: true, radius: 3 },
      data: sr_orig.slice(991, 1073),
      name: 'Training Data'
    },
    {
      marker: { enabled: true, radius: 3 },
      data: sr_1_8.slice(0, 73),
      name: 'Reservoir Prediction'
    }
  ]
};

const opts = { style: { height: '250px', width:'100%' }};

function SpectralRadius() {
  return (
    <div id="Spectral_radius" className="row">
      <h3>Spectral Radius</h3>
      <div className="w-100">
        <p>
          Spectral radius effectively controls the decay rate and range of interactions.
          Picking a spectral radius <InlineMath>r</InlineMath>, we tune the reservoir weight matrix using the ratio
        </p>
      </div>
      <div className="w-100">
        <BlockMath>{`W = W * \\frac{r}{\\lvert \\lambda^{\\downarrow}_{1}{W} \\rvert}`}</BlockMath>
      </div>
      <HighchartsReact
        highcharts={Highcharts}
        options={sr1}
        containerProps={opts}
      />
      <HighchartsReact
        highcharts={Highcharts}
        options={sr2}
        containerProps={opts}
      />
      <HighchartsReact
        highcharts={Highcharts}
        options={sr3}
        containerProps={opts}
      />
      <HighchartsReact
        highcharts={Highcharts}
        options={sr4}
        containerProps={opts}
      />
    </div>
  );
}

export default SpectralRadius;
